export const RFQ_QUOTE_CONFIRM_RFE_SENT = 'ConfirmRFESent';
export const RFQ_QUOTE_CONFIRM_RFE_DECLINE = 'ConfirmRFEDecline';
export const RFQ_QUOTE_CONFIRM_RFE_ACCEPT = 'ConfirmRFEAccept';
export const RFQ_QUOTE_CONFIRM_RFE_CLIENT_ACCEPT = 'ConfirmRFEClientAccept';
export const RFQ_QUOTE_CONFIRM_RFE_NOT_SENT = 'ConfirmRFENotSent';
export const RFQ_QUOTE_DEFAULT = 'Default';
export const RFQ_QUOTE_INDICATIVE = 'Indicative';
import { ApiPriceIsFrom, HedgeQuote } from '@approot/services';
import { KeyValue } from './generic';
import { PremiumStyle } from './rfq-tabs';

export type RfqQuoteStatus =
  | typeof RFQ_QUOTE_CONFIRM_RFE_SENT
  | typeof RFQ_QUOTE_CONFIRM_RFE_DECLINE
  | typeof RFQ_QUOTE_CONFIRM_RFE_ACCEPT
  | typeof RFQ_QUOTE_CONFIRM_RFE_NOT_SENT
  | typeof RFQ_QUOTE_DEFAULT
  | typeof RFQ_QUOTE_INDICATIVE
  | typeof RFQ_QUOTE_CONFIRM_RFE_CLIENT_ACCEPT;

export type DescriptionEntry = {
  text: string;
  headers: string[];
  title: string;
  rows: any[]; // XXXX Added to fix linting error in template - need to check if actually exists in data
};

export interface RfqBidOfferQuotes {
  bids: RfqQuote[];
  offers: RfqQuote[];
}

export type Vol = {
  value: number;
  buyOrSell: string;
  premium?: {
    value: number;
    cashValue: number;
    payOrReceive: string;
    buyOrSell: string;
    currency?: string;
    cashToPremiumStyleDividingAmount: number;
  };
};

export type BidAskByDateType = {
  date: string;
  amount: number;
  type: 'Receive' | 'Pay';
  currency: string;
};

export type RfqQuote = {
  type: string;
  bank: string;
  hedge: HedgeData;
  id: number;
  bidAsk: BidAskData;
  bidAsksByDate: BidAskByDateType[];
  vol: {
    left: Vol[];
    right: Vol[];
  };
  cashToPremiumStyleDividingAmounts: number[];
  legPremiums: any[];
  legCashPremiums: any[];
  legsInverted: boolean[];
  quotedPremiumSection: QuotedPremiumSection;
  quoteId: number;
  providerId: number;
  status: RfqQuoteStatus;
  timestamp: number; // timestamp the quote came in
  timeLimit: number;
  description: {
    bid: DescriptionEntry[];
    ask: DescriptionEntry[];
  };
  spotPremium: KeyValue;
  forwardPremium: KeyValue;
  legPremium: KeyValue;
  premiumStyle: PremiumStyle;
  indicativePremium: IndicativePremium;
  apiPriceIsFrom: ApiPriceIsFrom;
  premiumCurrency: string;
  executionContextType: string;
  premiumInPercent?: number;
  pips?: number;
  frozenQuote?: boolean;
  hedgeQuotes?: HedgeQuote[];
  quoteReference?: string;
  executionType?: 'Live' | 'DX';
  outdated?: boolean;
};

export type QuoteSide = 'bid' | 'offer';

export type QuotedPremiumSection = {
  quotedPremium: number;
  showPercent: boolean;
  currency: string;
  isPips?: boolean;
};

export type HedgeData = {
  type: string;
  amount: number;
  currency: string;
  value: number;
};

export type BidAskData = {
  type: string;
  currency: string;
  amount: number;
  marginSpread?: number;
  color?: string;
};

export type RfeAction = {
  bank: string;
  providerId: number;
  type: string;
  status: RfqQuoteStatus;
};

export interface IndicativePremium {
  premiumBidPercentBase: number;
  premiumBidPercentTerm: number;
  premiumBidPipsTerm: number;
  premiumOfferPercentBase: number;
  premiumOfferPercentTerm: number;
  premiumOfferPipsTerm: number;
}
